import React from 'react'
import SarasTrans from '../../../library/notifications/SarasTrans';
//starting with capital letter will ensure this is treated as a component
const QCGridItemH = ({col}) => {

    return (
        <div className="uiSearchQCItemList">
            <span className="sItemID uiCenter"><SarasTrans value="Items" /></span>
        </div>
    );
}

export default QCGridItemH
